export const siteSettings = {
  name: "Pulse Digital Markets",
  link: "https://pulsedigitalmarkets.com",
  email: "support@pulsedigitalmarkets.com",
  appLink: "https://app.pulsedigitalmarkets.com",
};
